import React from 'react';
import { DateTime } from 'luxon';
import { usePlanTableQuery } from 'generated/graphql';
import _ from 'lodash';


export type IData = {
  createdDate: DateTime;
  id: string;
  name: string;
  planSetDisplayName: string;
  updatedDate: DateTime;
  versionCount: string;
};

export function useQuery(id: string, planSetId: string | undefined) {
  const tuple = usePlanTableQuery({
    variables: {
      options: {
        filter: {
          projectId: id,
          planSetId
        }
      }
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const plans = tuple.data?.plans.map((node) => {
        if (!node) {
          return null;
        }

        return {
          createdDate: node.createdDate ?? DateTime.now(),
          id: node.id ?? '',
          name: node.name ?? '',
          planSetDisplayName: node.planSet.displayName ?? '',
          updatedDate: node.updatedDate ?? DateTime.now(),
          versionCount: _.toString(node.versions.length ?? 0)
        };

      }) ?? [];

      const data: IData[] = _.compact(plans) ?? [];

      return {
        ...tuple,
        data
      };
    }
    , [tuple]
  );
}
